import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "rulesets",
    defaultRoutePath: "/partnershipDeals/ruleset",
    menuItemScope: "partnershipDeals",
    menuItemName: "rulesets",

    routes: [
        {
            path: "/partnershipDeals/ruleset",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        
        {
            path: "create",
            Component: Wizards.Create,
        },
    ],

}

export default Module;
